import React from 'react';

import './style.scss';

function HeaderTitle(){
  return (
    <h1 className="header-title">
      استارت‌آپ، از رویا تا <span className="highlight">حقیقتـــ</span>
    </h1>
  );
}

export default HeaderTitle;